import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_production/69909c9df782d50014d938bb_1790606385582_74febefc/frenacal/node_modules/next/dist/client/app-dir/link.js");
